import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import validationform from '../../validation/validationform';
import { SignupService } from './service/signup.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import intlTelInput from 'intl-tel-input';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss'
})
export class SignUpComponent {

  signUpForm:FormGroup = new FormGroup({});
  type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  storeSignUpForm: any;
  submitted!: boolean;
  spinner: boolean = false;
 
  countryCode1: any;
  countryCode2: any;
  response: any = [];

  separateDialCode = false;
  selectedCountryCode:any;

  private readonly notifier: NotifierService;
  selectedTranscribe!: number;
  transcribeList = [
    { id: 1, name: 'AWS' },
    { id: 2, name: 'Google' },
     {id:3,name:'Canstring AI'}
  ];

  initContry:any;
  formattedValue:any;
  @Output() formChange:EventEmitter<any>=new EventEmitter();
  @ViewChild('intlInput') intlInput!: ElementRef;
  constructor(private fb: FormBuilder, private notifierService: NotifierService,private signUpService:SignupService,private config: NgSelectConfig){
    this.notifier = notifierService;
  }

  ngOnInit(){
    this.signUpForm = this.fb.group({
      companyname: [null,[Validators.required,Validators.pattern(/^[A-Za-z0-9\s\'\&\-]*$/)]],
      location: [null, [Validators.required,Validators.pattern(/^[A-Za-z0-9\s\'\&\-]*$/)]],
      username: [null, [Validators.required,Validators.pattern(/^[A-Za-z0-9\s\'\&\-]*$/)]],
      transcribe: [3, Validators.required],
      email: [null, [Validators.required,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      password: [
        null,
        [
          Validators.required,
          Validators.pattern(
            '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{8,12}'
          ),
        ],
      ],
      phonenumber: [
        '',
        [Validators.required, Validators.pattern('[- +()0-9]+.{9,}'),Validators.maxLength(10)],
      ],
      agent: [null],
      terms: [null, [Validators.required, Validators.requiredTrue]],
    });
    this.signUpForm.controls['agent'].setValue(10);

    
  }

  get f(): { [key: string]: AbstractControl } {
    return this.signUpForm.controls;
  }

  hideShowPassword() {
    this.isText = !this.isText;
    this.isText ? (this.eyeIcon = 'fa-eye') : (this.eyeIcon = 'fa-eye-slash');
    this.isText ? (this.type = 'text') : (this.type = 'password');
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  onSubmit() {
    this.submitted = true;
    this.signUpForm.markAllAsTouched();
    const value = this.signUpForm.value;
    this.countryCode2 = this.initContry.getSelectedCountryData().dialCode;
  
    const email = value.email;
    const password = value.password;
    const possible =  "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
    const dynamic_str = this.makeRandom(16, possible);
    const salt = this.makeRandom(16, possible);
    const iterations = 128;
    const bytes = CryptoJS.PBKDF2(dynamic_str, salt, {
      keySize: 48,
      iterations: iterations,
    });
    const iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    const key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));

    const ciphertext = CryptoJS.AES.encrypt(password, key, { iv: iv });
    const formEncript = {
      email: email?.trim(),
      encrypted_data: ciphertext.toString(),
      salt: salt,
      pass_phrase: dynamic_str,
      company_name: value.companyname,
      location: value.location,
      maximum_file_per_agent: value.agent ? value.agent : null,
      transcribetype: value.transcribe,
      username: value.username,
      phonenumber:
        (!value.phonenumber.includes('+91')
          ? '+' +
            (this.countryCode2
              ? this.countryCode2
              : this.countryCode1
            ).toString()
          : '') + value.phonenumber.toString(),
    };
  //  this.formChange.emit("verify");
    if (this.signUpForm.valid) {
      this.spinner = true;
      this.signUpService.signUp(formEncript).subscribe({
        next: (response) => {
          localStorage.setItem('loginuser',formEncript['email']);
          this.response = response;
         // this.returnBack('verify');
         this.formChange.emit("verify");
         this.notifier.notify('default', 'Account created successfully. A verification code has been sent to your registered email.');
          this.spinner = false;
        },
        error: (err) => {
          console.log('signUp error', err);
          this.spinner = false;
        },
      });
    } else {
      validationform.ValidateAllFormFields(this.signUpForm);
    }
  }
  returnBack(value: string) {
  //  this.returnToLoginEmitter.emit({ make: false, name: value });
    this.formChange.emit(value);
  }

  getNumber(event: any) {}

  onCountryChange(event: any) {
    this.countryCode2 = event?.dialCode;
  }

  hasError(event: any) {}

  telInputObject(event: any) {
    this.countryCode1 = event.s.dialCode;
  }

  ngAfterViewInit() {
    this.initContry = intlTelInput(this.intlInput.nativeElement, {
      allowDropdown: true,
      nationalMode: true,
      initialCountry: 'in',
      separateDialCode: false
    });

   
  
    //controller.setCountry('JP');
    //controller.setNumber('9726502930');
  }

    onInputPhoneChange(event:any){
      if(event.target.value.length > 17){
        event.preventDefault();
        let input = event.target.value;
        this.formattedValue = input.slice(0,17);
        this.signUpForm.controls['phonenumber'].setValue(this.formattedValue);
      }
    }

}
